import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
  CANNED_RESPONSE_PERMISSIONS,
} from 'dashboard/constants/permissions';
import SettingsWrapper from '../SettingsWrapper.vue';
import WhatsappInteractiveTemplates from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/whatsapp-interactive-templates'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'whatsapp_interactive_templates',
          meta: {
            permissions: [
              ...ROLES,
              ...CONVERSATION_PERMISSIONS,
              CANNED_RESPONSE_PERMISSIONS,
            ],
          },
          component: WhatsappInteractiveTemplates,
        },
      ],
    },
  ],
};
